<template>
  <Modal v-model="setAliasModal" :title="$t('key1005670')" width="1000" :transfer="false" :mask-closable="false"
    @on-visible-change="setAliasChange">
    <!--YMSSPU-->
    <div class="flex align-items-center">
      <span class="color-000 font-weight-bold">{{ $t('key1000100') }}</span>
      <span class="color-666">{{ detailsData.name }}</span>
      <span class="color-000 font-weight-bold ml40">{{ configCharacters(false) + 'SPU：' }}</span>
      <span class="color-666">{{ detailsData.ymsSpu }}</span>
    </div>
    <Divider style="margin: 10px 0 15px 0;"/>
    <!--YMSSKU-->
    <div style="max-height: 500px; overflow-y: auto;">
      <div class="mb10" v-for="(item,index) in setAliasData">
        <p class="flex align-items-center mb8">
          <Badge color="#FD5425" class="color-000 font-weight-bold" :text="configCharacters(false) + 'SKU：'"/>
          <span class="color-666">{{ item.ymsSku }}</span>
          <span class="distributorThemeColor ml20">{{ item.specifications }}</span>
        </p>
        <div class="flex flex-wrap">
          <div class="alias_item_box" v-for="(ele, idx) in item.aliasList" :class="(ele.ymsSkuAlias && ele.identicalYmsSkuAlias) ||
           (ele.ymsSkuAlias && ele.existingYmsSku) ? 'ivu-form-item-error' : ''">
            <Input :placeholder="$t('key1005671')" clearable v-model.trim="ele.ymsSkuAlias" style="width: 185px;" @on-focus="focusChange"></Input>
            <Icon type="ios-trash-outline" size="22" color="#FD5425" v-if="idx !==item.aliasList.length -1"
              class="ml5 mr24 cursor" @click="deleteAliasBtn(index, idx)"/>
            <Icon type="md-add-circle" size="22" color="#FD5425" v-else
              class="ml5 cursor" @click="addAliasBtn(index)"/>
            <span class="tips_item_box" v-if="ele.ymsSkuAlias && ele.identicalYmsSkuAlias">{{ $t('key1005676') }}</span>
            <span class="tips_item_box" v-if="ele.ymsSkuAlias && ele.existingYmsSku && !ele.identicalYmsSkuAlias">
              {{ $t('key1005672') + configCharacters(false) + 'SKU' + ' “ ' + ele.existingYmsSku + ' ” ' + $t('key1000690') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <p class="color-666 mt20">
      {{ $t('key1000615') }}<br/>
      {{
        $t('key1005673') + configCharacters() + $t('key1005674')
          + configCharacters() + $t('key1005675')
      }}
    </p>
    <template #footer>
      <Button @click="setAliasModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="setAliasBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'setAliasModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      setAliasModal: false,
      detailsData: {},
      setAliasData: [],
    };
  },
  computed: {},
  created() {

  },
  methods: {
    // 初始化数据
    initSetAliasData(ymsProductGoodsIdList) {
      if (ymsProductGoodsIdList.length > 0) {
        this.axios.post(api.post_ymsDistributorProductInfo_queryByYmsProductGoodsIds, ymsProductGoodsIdList, {loading: true}).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas || [];
            if (data.length > 0) {
              this.detailsData = data[0];
              let ymsProductGoodsList = this.detailsData.ymsProductGoodsList || [];
              ymsProductGoodsList.map((item) => {
                let productGoodsSpecifications = item.productGoodsSpecificationList || [];
                item.specifications = productGoodsSpecifications.map(i => i.value).join(' • ') || '';
                item.aliasList = item.ymsProductGoodsMappingList || [{ymsSkuAlias: ''}];
              });
              this.setAliasData = ymsProductGoodsList;
            }
          }
        });
      }
      this.setAliasModal = true;
    },
    // 删除别名
    deleteAliasBtn(index, idx) {
      this.setAliasData[index].aliasList.splice(idx, 1);
      this.$forceUpdate();
    },
    // 新增别名
    addAliasBtn(index) {
      this.setAliasData[index].aliasList.push({ymsSkuAlias: ''});
      this.$forceUpdate();
    },
    // 确定按钮
    setAliasBtn() {
      let list = [];
      if (this.setAliasData.length > 0) {
        for (const item of this.setAliasData) {
          for (const ele of item.aliasList) {
            if (ele.ymsSkuAlias) {
              list.push({
                ymsProductGoodsId: item.ymsProductGoodsId,
                ymsSkuAlias: ele.ymsSkuAlias,
                ymsProductId: item.ymsProductId,
                ymsSku: item.ymsSku,
              });
            }
          }
        }
        this.axios.post(api.post_ymsProductGoodsMapping_saveAlias, list, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas || [];
            if (data.length > 0) {
              this.setAliasData.map((item) => {
                item.aliasList.map((ele) => {
                  ele.identicalYmsSkuAlias = false;
                  ele.existingYmsSku = null;
                  data.map((talg) => {
                    if (talg.ymsSkuDb === item.ymsSku) {
                      if (talg.ymsSkuAlias === ele.ymsSkuAlias) {
                        ele.identicalYmsSkuAlias = true;
                      }
                    } else {
                      if (!ele.identicalYmsSkuAlias) {
                        if (talg.ymsSkuAlias === ele.ymsSkuAlias) {
                          ele.existingYmsSku = talg.ymsSkuDb;
                        }
                      }
                    }
                  });
                });
              });
              this.$forceUpdate();
            } else {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              this.setAliasModal = false;
            }
          }
        });
      }
    },
    // 获取焦点时，清空所有校验提示
    focusChange() {
      for (const item of this.setAliasData) {
        for (const ele of item.aliasList) {
          ele.identicalYmsSkuAlias = false;
          ele.existingYmsSku = null;
        }
      }
      this.$forceUpdate();
    },
    // 监听弹窗
    setAliasChange(value) {
      if (!value) {
        this.detailsData = {};
        this.setAliasData = [];
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less" scoped>
.alias_item_box {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  position: relative;

  .tips_item_box {
    width: 95%;
    font-size: 12px;
    color: #ed4014;
    position: absolute;
    top: 35px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
